var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeaderBackgroundSensia = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 360,
  height: 223,
  viewBox: "0 0 360 223",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M348.146 189.98L14.9498 222.923C6.98363 223.707 0 218.428 0 211.631V0H360V178.688C360 184.459 354.908 189.313 348.146 189.98Z",
  fill: "#86AA63"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeaderBackgroundSensia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/header-background-sensia.54a36974921d55937384c6dc10f80017.svg";